export default __webpack_public_path__ + "static/media/cpr8.1f3e1cca.jpg";